import {
  GET_PAYOUT_COUNT_NETWORK,
  GET_PAYOUT_DETAILS_LIST,
  GET_TOTAL_PROVIDERS_PAYOUT,
  GET_TOTAL_APPOINTMENT_PAYOUT,
  GET_FINANCE_QC,
  GET_QC_APPROVAL_APPOINTMENT,
  GET_PAYABLE_ACTION,
  ADVANCE_PAYOUT_DETAIL,
  GET_PAYOUT_STATUS,
  GET_INSURER_TEST_PACKAGE_DETAIL,
  GET_ADVANCE_PAYMENT_ACTION,
  GET_HISTORY,
  GET_INFORMATION_ACCESS,
  GET_TOTAL_CLOSED_APPOINTMENT,
  GET_PAYOUT_DASH,
} from "../../Utils/types";

const init = {
  getPayoutNetworkCount: {},
  getPayoutDetailsList: [],
  getTotalProviderPayout: [],
  getTotalAppointmentPayout: [],
  getFinanceQc: [],
  getQcApprovalAppt: [],
  advancePayoutDetail: [],
  getpayoutStatus: [],
  getInsurerPackageDetail: null,
  getAdvancePaymentFlow: [],
  getInformationAccess: null,
  getTotalClosedAppointment:[],
  PayoutDashDataReducer:[],
};

export default (state = init, action) => {
  switch (action.type) {
    case GET_PAYOUT_COUNT_NETWORK:
      return {
        ...state,
        getPayoutNetworkCount: action.payload,
      };
    case GET_PAYOUT_STATUS:
      return {
        ...state,
        getpayoutStatus: action.payload,
      };
    case GET_PAYOUT_DETAILS_LIST:
      return {
        ...state,
        getPayoutDetailsList: action.payload,
      };
    case GET_TOTAL_PROVIDERS_PAYOUT:
      return {
        ...state,
        getTotalProviderPayout: action.payload,
      };
    case GET_TOTAL_APPOINTMENT_PAYOUT:
      return {
        ...state,
        getTotalAppointmentPayout: action.payload,
      };
    case GET_FINANCE_QC:
      return {
        ...state,
        getFinanceQc: action.payload,
      };
    case GET_QC_APPROVAL_APPOINTMENT:
      return {
        ...state,
        getQcApprovalAppt: action.payload,
      };
    case GET_PAYABLE_ACTION:
      return {
        ...state,
        getPayableData: action.payload,
      };
    case ADVANCE_PAYOUT_DETAIL:
      return {
        ...state,
        advancePayoutDetail: action.payload,
      };
    case GET_INSURER_TEST_PACKAGE_DETAIL:
      return {
        ...state,
        getInsurerPackageDetail: action.payload,
      };
    case GET_ADVANCE_PAYMENT_ACTION:
      return {
        ...state,
        getAdvancePaymentFlow: action.payload,
      };
    case GET_HISTORY:
      return {
        ...state,
        getHistory: action.payload,
      };
    case GET_INFORMATION_ACCESS:
      return {
        ...state,
        getInformationAccess: action.payload,
      };
    case GET_TOTAL_CLOSED_APPOINTMENT:
      return {
        ...state,
        getTotalClosedAppointment: action.payload,
      };
    case GET_PAYOUT_DASH:
      return {
        ...state,
        PayoutDashDataReducer: action.payload,
      };
    default:
      return state;
  }
};
